<template>
  <div class="pull-left">
    <button class="btn btn-info btn-sm" data-toggle="modal" data-target=".modal-job-history">Event Log</button>
    <div class="margin-20"></div>

    <div class="modal fade modal-job-history" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            Job Event Log
          </div>

          <div class="modal-body">
            <ul class="list-detail list-detail-job-history">
              <history-item v-for="(item, index) in history" :key="index" :item="item"></history-item>

              <li v-show="haveNoHistory" class="text-muted text-center">
                There are no events.
              </li>
            </ul>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import HistoryItem from './HistoryItem'
  import $ from 'jquery'

  export default {
    components: {
      HistoryItem
    },

    computed: {
      ...mapState('job/history', ['history']),

      haveNoHistory () {
        return this.history.length === 0
      }
    },

    mounted () {
      $('.modal-job-history').on('show.bs.modal', this.getHistory)
    },

    beforeDestroy () {
      $('.modal-job-history').off('show.bs.modal', this.getHistory)
    },

    methods: {
      ...mapActions('job/history', ['getHistory'])
    }
  }
</script>



// WEBPACK FOOTER //
// History.vue?00342d9c